// extracted by css-extract-rspack-plugin
module.exports =  {"adrDataWrap":"jGEZc","logo":"uzfr_"};